import { render, staticRenderFns } from "./FIBScratchCard.vue?vue&type=template&id=38e0d5f1&scoped=true&"
import script from "./FIBScratchCard.vue?vue&type=script&lang=js&"
export * from "./FIBScratchCard.vue?vue&type=script&lang=js&"
import style0 from "./FIBScratchCard.vue?vue&type=style&index=0&id=38e0d5f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e0d5f1",
  null
  
)

export default component.exports
import QColor from 'quasar/src/components/color/QColor.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QColor});
